import React, { useEffect, useState, useCallback, useMemo } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import OptionTerms from "./OptionTerms";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import TestCourse from "./TestCourse";
import OptionsPaymentDate from "./OptionsPaymentDate";
import PaymentDate from "./PaymentDate";

const Terms = React.memo(({ terms }) => {
  const [gridSize, setGridSize] = useState(10);
  const [open, setOpen] = useState(false);
  const [optionTermId, setOptionTermId] = useState("");

  useEffect(() => {
    if (!open) setOptionTermId("");
  }, [open]);

  const handlePageSizeChange = useCallback((newSize) => {
    setGridSize(newSize);
  }, []);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const allOptions = terms;

  const groupedByDiscount = Object.values(
    allOptions.reduce((acc, option) => {
      const { discount, optionId, terms } = option;

      // If this discount group doesn't exist yet, initialize it
      if (!acc[discount]) {
        acc[discount] = {
          discount: `${discount} %`,
          options: [],
        };
      }

      // Push the option data to its group
      acc[discount].options.push({
        optionId,
        terms,
      });

      return acc;
    }, {})
  );

  // Optional: sort by discount ascending
  groupedByDiscount.sort((a, b) => a.discount - b.discount);

  console.log(groupedByDiscount);

  const columns = useMemo(
    () => [
      {
        field: "serialNumber",
        headerName: "SlNo",
        width: 60,
      },
      {
        field: "discount",
        headerName: "Discount",
        width: 100,
      },
      {
        field: "OptionTerms",
        headerName: "Option Terms",
        width: 550,
        renderCell: (params) => (
          <TestCourse
            setOptionTermId={setOptionTermId}
            data={params.row.options}
            // id={params.row.options.optionId}
          />
        ),
      },
      // {
      //   field: "OptionTerms",
      //   headerName: "Option Terms",
      //   width: 550,
      //   renderCell: (params) => {
      //     console.log("paraaaa", params.row.options);
      //   },
      // },
      // {
      //   field: "CheckDate",
      //   headerName: "Check Date",
      //   width: 300,
      //   renderCell: (params) =>
      //     params.row.optionId === optionTermId ? (
      //       <OptionsPaymentDate optionTermId={optionTermId} />
      //     ) : null,
      // },
    ],
    [optionTermId]
  );

  const [discount, setDiscount] = React.useState({});
  console.log("discount", discount);
  const TblData = discount.options?.map((list, index) => ({
    ...list,
    serialNumber: index + 1,
    term: `Term ${index + 1}`,
  }));
  const handleChange = (event) => {
    console.log("event.target.value", event.target.value);

    const selectedDiscount = groupedByDiscount.find(
      (item) => item.discount === event.target.value
    );
    setDiscount(selectedDiscount);
  };

  const rows = useMemo(() => {
    return (
      terms?.map((term, index) => ({
        ...term,
        serialNumber: index + 1,
        discount: `${term.discount} %`,
      })) || []
    );
  }, [terms]);

  return (
    <GlobalDialog
      title="Discount"
      open={open}
      setOpen={setOpen}
      closeButton
      maxWidth="lg"
      fullWidth
      popupButton={
        <Button
          sx={{
            color: "white",
            background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
            borderRadius: 4,
          }}
          size="small"
          onClick={handleOpen}
        >
          View Discount and Terms
        </Button>
      }
      content={
        open && (
          <Box>
            <Box>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Discount</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={discount?.discount || ""}
                  label="Discount"
                  onChange={handleChange}
                >
                  {groupedByDiscount.map((item) => {
                    return (
                      <MenuItem value={item.discount} key={item.discount}>
                        {item.discount}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>

            <GlobalWrapper>
              {discount?.options?.map((item) => {
                return (
                  <>
                    {/* <Chip label={`OPTIONID:${item.optionId}`} /> */}

                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <PaymentDate optionTermId={item.optionId} />
                    </Box>

                    <Box p={3}>
                      <TableContainer
                        sx={{ backgroundColor: "grey.200" }}
                        elevation={3}
                        component={Paper}
                      >
                        <Table
                          sx={{ minWidth: 400 }}
                          aria-label="INR and AED Terms table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>Term</TableCell>
                              <TableCell>INR Term</TableCell>
                              <TableCell>AED Term</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {item?.terms.map((tm, i) => (
                              <TableRow
                                key={i} // It's better to use a unique ID from 'tm' if available, otherwise index is a fallback
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  Term {i + 1}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  {tm.InrTerm}
                                </TableCell>
                                <TableCell>{tm.AedTerm}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                    {/* <Box>
                      {item?.terms.length > 0 ? (
                        <>
                          {" "}
                          {item?.terms?.map((term) => (
                            <Box
                              sx={{
                                width: "100%",
                                p: 1,
                              }}
                            >
                              <TableContainer component={Paper}>
                                <Table aria-label="simple table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>serialNumber</TableCell>
                                      <TableCell align="right">Terms</TableCell>
                                      <TableCell align="right">
                                        InrTerm
                                      </TableCell>
                                      <TableCell align="right">
                                        AedTerm
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {term?.map((row, i) => (
                                      <TableRow
                                        key={row.serialNumber}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        <TableCell component="th" scope="row">
                                          {i + 1}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row.term}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row.InrTerm}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row.AedTerm}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          ))}
                        </>
                      ) : null}
                    </Box> */}
                  </>
                );
              })}
            </GlobalWrapper>

            {/* <GlobalWrapper>
              <DataGrid
                rows={groupedByDiscount}
                columns={columns}
                getRowHeight={() => "auto"}
                getRowId={(row) => row.discount}
                pageSize={gridSize}
                autoHeight
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
              />
            </GlobalWrapper> */}
          </Box>
        )
      }
    />
  );
});

export default Terms;
